export default __webpack_public_path__ + "static/media/LogoAZUL.f023d28c.svg";